import {useDebugValue} from 'react';

import {useSystemOptions} from './';

function useSystem(props) {
    const {
        options
    } = useSystemOptions(props);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useSystem};
